import classnames from 'classnames';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';
import type { AppEmbedData as AppEmbedDataLegacy } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { AppEmbedData } from './../../ricos-schema/next-schema';
import type { Helpers, LegacyEditorPluginConfig } from './../../ricos-types';
import { Node_Type } from './../../ricos-types';
import { getLangDir } from './../../wix-rich-content-common';

import Card from '../components/Card';
import { convertDuration } from '../convertDuration';
import { ROOT } from '../data-hooks';
import styles from '../statics/styles/widget-scss';
import { VERTICAL_EMBED_TYPE } from '../types';

interface Props {
  helpers: Helpers;
  settings: LegacyEditorPluginConfig;
  componentData: AppEmbedData;
  nodeId: string;
}

export const VerticalEmbedViewer: React.FC<Props> = ({
  settings,
  componentData,
  helpers,
  nodeId,
}) => {
  const { t, locale } = useContext(RicosContext);
  const onClick = () =>
    helpers.onViewerAction?.(VERTICAL_EMBED_TYPE, 'Click', componentData.type, nodeId, {
      type: Node_Type.APP_EMBED,
      appEmbedData: componentData as AppEmbedDataLegacy,
    });

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={classnames(styles.card, { [styles.slimLayout]: settings.slimLayout })}
      data-hook={ROOT}
      onClick={onClick}
    >
      <Card
        url={settings.changeBaseUrl ? settings.changeBaseUrl(componentData.url) : componentData.url}
        title={componentData.name}
        image={componentData.image}
        buttonText={t(
          {
            PRODUCT: 'VerticalEmbed_Products_Button',
            EVENT: 'VerticalEmbed_Events_Button',
            BOOKING: 'VerticalEmbed_Bookings_Button',
          }[componentData.type]
        )}
        t={t}
        direction={getLangDir(locale)}
        disabled={settings.disabled}
        subtitleInfo={
          componentData.type === 'EVENT' && componentData.eventData
            ? {
                leftSubtitle: componentData.eventData.scheduling,
                rightSubtitle: componentData.eventData.location,
              }
            : componentData.type === 'BOOKING' && componentData.bookingData
            ? {
                leftSubtitle: convertDuration(componentData.bookingData.durations, t),
                rightSubtitle: undefined,
              }
            : undefined
        }
      />
    </div>
  );
};
